import { useState } from "react";

// CSS background-image yerine <img> kullanıyoruz:
// - decoding="async": decode işlemi main thread'i bloke etmez
// - fetchPriority="high": tarayıcı bu görseli en yüksek öncelikle indirir
// - Yüklenene kadar koyu #0A0A0A placeholder, ardından opacity fade-in
const HeroBackground = ({ src, position = "center center", className = "" }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`absolute inset-0 overflow-hidden bg-[#0A0A0A] ${className}`}>
      <img
        src={src}
        alt=""
        aria-hidden="true"
        decoding="async"
        fetchPriority="high"
        loading="eager"
        onLoad={() => setLoaded(true)}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: position,
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.5s ease",
          willChange: "opacity",
        }}
      />
    </div>
  );
};

export default HeroBackground;
